const { transformEnumToObject } = require('@/tools');
const {
  CHANNEL_INTERFACE_TYPE,
  CHANNEL_INTERFACE_TEXT,
  ADVERTISER_SOURCE_TYPE,
  ADVERTISER_SOURCE_TEXT,
} = require('@/enums');

module.exports = (s) => {
  return [
    {
      name: '媒体平台',
      value: 'advertiser',
      format: (row) => {
        const { advertiser } = row;
        const channel_interface_map = transformEnumToObject(CHANNEL_INTERFACE_TYPE, CHANNEL_INTERFACE_TEXT);
        return channel_interface_map[advertiser];
      },
    },
    {
      name: '广告主账户',
      value: 'advertiser_id',
    },
    {
      name: '模板名称',
      value: 'name',
    },
    {
      name: '操作目标',
      value: 'advertiser_source_type',
      format: (row) => {
        const { advertiser_source_type } = row;
        const advertiser_source_type_map = transformEnumToObject(ADVERTISER_SOURCE_TYPE, ADVERTISER_SOURCE_TEXT);
        return advertiser_source_type_map[advertiser_source_type];
      },
    },
    {
      name: '提交状态',
      value: 'status',
      format: (row) => {
        const { status } = row;
        const status_map = {
          1: '提交中',
          2: '提交完成',
          6: '重试中',
        };
        return status_map[status];
      },
    },
    {
      name: '提交结果',
      value: 'result',
      width: 200,
      format: (row) => {
        const { result: { success_num = 0, fail_num = 0 } = {}, status } = row;
        const h = s.$createElement;
        const ele = h('div', null, [
          h('span', { class: 'color-green' }, `成功：${success_num}`),
          h('span', { class: 'color-red ml-10' }, `失败：${fail_num}`),
        ]);
        return status === 1 ? '-' : ele;
      },
    },
    {
      name: '创建时间',
      value: 'created_at',
    },
    {
      name: '状态更新时间',
      value: 'updated_at',
    },
    {
      name: '操作',
      width: 80,
      format: (row) => {
        const { id } = row;
        const h = s.$createElement;
        const ele = h('div', null, [
          h('el-button',
            {
              props: {
                size: 'mini',
                type: 'primary',
              },
              on: {
                click: () => {
                  s.onView(id);
                },
              },
            },
            '详情'
          ),
        ]
        );
        return ele;
      },
    },
  ];
};
